import { IncomeModel } from '../../../../../../../ProfileOPL/Income/api/useIncomeQuery';

export interface IncomeWhatIfFormValues extends IncomeModel {
  IsBasePlanIncome: boolean;
}

export interface FormValues {
  WhatIfKey: string;
  WhatIfType: number;
  WhatIfTypeName: string;
  Incomes: IncomeWhatIfFormValues[];
}

export const DEFAULT_INCOME = {
  IncomeType: null,
  IsBasePlanIncome: false,
};

export const DEFAULT_VALUES: FormValues = {
  Incomes: [],
  WhatIfKey: '1200',
  WhatIfType: 1200,
  WhatIfTypeName: 'IncomeChanges',
};
